<template>
  <div class="row filter-row">
    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus position-relative">
        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
          style="z-index: 100; font-size: 12px;">Start Date</label>
        <div class="cal-icon" style="z-index: 90;">
          <date-picker v-model="startDate" placeholder="Start Date" class="form-control floating datetimepicker"
            :editable="true" :clearable="false" :inputFormat="dateFormat" @update:model-value="loadClick" />
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus position-relative">
        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
          style="z-index: 100; font-size: 12px;">End Date</label>
        <div class="cal-icon" style="z-index: 90;">
          <date-picker v-model="endDate" placeholder="End Date" class="form-control floating datetimepicker"
            :editable="true" :clearable="false" :inputFormat="dateFormat" @update:model-value="loadClick" />
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-md-3">
      <a href="javascript:;" class="btn btn-secondary mb-3 btn-sm w-100 me-2" data-bs-toggle="modal"
        data-bs-target="#select_banked_user_modal">Select Employee</a>
    </div>
    <div class="col-sm-6 col-md-3">
      <a href="javascript:;" class="btn btn-success btn-sm mb-3 w-100" @click="downloadClick">Download</a>
    </div>
  </div>
  <select-banked-user-modal @onUsersSelected="selectedUsers"></select-banked-user-modal>
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: {
    getSelectedValues: {
      type: Function
    },
    downloadUsers: {
      type: Function
    },
  },
  data() {
    const today = new Date();
    return {
      startDate: today,
      endDate: new Date(today.getFullYear(), 11, 31),
      dateFormat: 'dd/MM/yyyy',
      filterdUsers: []
    };
  },
  mounted() {
  },
  methods: {
    selectedUsers(value) {
      this.filterdUsers = value;
      this.loadClick();
    },

    downloadClick() {
      this.downloadUsers();
    },

    loadClick() {
      let date = {
        start_date: this.startDate ? dayjs(this.startDate).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
        end_date: this.endDate ? dayjs(this.endDate).format('YYYY-MM-DD') : dayjs(new Date(new Date().getFullYear(), 11, 31)).format('YYYY-MM-DD'),
      };

      this.getSelectedValues(this.filterdUsers, date);
    }
  }
};
</script>
